<script lang="ts" setup>
  import { StoreLayout, AccountLayout } from '@storefront/components';
  import type { ComplaintAndRefundAddress, Refund, RefundItem } from '@storefront/resources';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  interface Props {
    refund: Refund;
    refundReturnAddress: ComplaintAndRefundAddress;
    items: RefundItem[];
  }

  defineProps<Props>();
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.refund.index')">
    {{ $t('SHOP.ACCOUNT.HEADER.REFUND_DETAILS') }}
  </AccountMobileNavigation>
  <RefundDetailsView v-bind="$props" />

  <RouterView />
</template>
